// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"43047be7","32":"ec4ed826","281":"12b0764d","424":"25051319"}[chunkId] + ".chunk.css";
};